import { useState } from "react";
import { Button, Grid, IconButton, Popover } from "@mui/material";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import RenameModal from "./RenameModal";
import DeleteModal from "./DeleteModal";

const ItemConfig = ({ chatId, chatTitle }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [renameModalOpen, setRenameModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <Grid>
            <IconButton
                sx={{
                    marginX: '5px',
                }}
                onClick={handleClick}
            >
                <MoreHorizIcon fontSize="small" />
            </IconButton>

            <RenameModal
                open={renameModalOpen}
                setOpen={setRenameModalOpen}
                chatId={chatId}
                chatTitle={chatTitle}
            />

            <DeleteModal
                open={deleteModalOpen}
                setOpen={setDeleteModalOpen}
                chatId={chatId}
            />

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                <Grid
                    sx={{
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                    }}
                >
                    <Grid>
                        <Button
                            sx={{
                                justifyContent: 'flex-start',
                                width: '100%',
                                gap: '10px',
                            }}
                            onClick={() => setRenameModalOpen(true)}
                            startIcon={<DriveFileRenameOutlineIcon fontSize="small" />}
                        >
                            Rename
                        </Button>
                    </Grid>
                    <Grid>
                        <Button
                            sx={{
                                justifyContent: 'flex-start',
                                width: '100%',
                                gap: '10px',
                            }}
                            onClick={() => setDeleteModalOpen(true)}
                            startIcon={<DeleteIcon fontSize="small" />}
                        >
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </Popover>
        </Grid>
    );
}

export default ItemConfig;